import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";

import { AppErrorAction } from "./app-error.action";
import { AppError, AppErrorType } from "./app-error.model";

@Injectable({
	providedIn: "root",
})
export class AppErrorService {
	mapErrorTypeToAction(error: AppError): Action {
		switch (error.type) {
			case AppErrorType.BadRequest: {
				return AppErrorAction.badRequestError(error);
			}
			case AppErrorType.Unauthorized: {
				return AppErrorAction.unauthorizedError(error);
			}
			default:
				return AppErrorAction.serverError(error);
		}
	}
}
